// Node
import { difference, intersection, pluck } from 'underscore';

import axios from 'axios';
import $ from 'jquery';
import { filtersToQuery, sortForMap, zIndexForMapMarker } from '../filter_utils';

export default class Map extends React.Component {
  constructor(props) {
    super(props);
    this.loadCamps = this.loadCamps.bind(this);
    this.initMarkers = this.initMarkers.bind(this);
    this.refreshMap = this.refreshMap.bind(this);
    this.filterCampsInBorder = this.filterCampsInBorder.bind(this);
    this.handleMapClick = this.handleMapClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlePopstate = this.handlePopstate.bind(this);
    this.state = {
      balloonCamp: null,
      balloonX: 0,
      balloonY: 0,
      loadingCamps: false,
      campsInBorders: [],
      allCamps: [],
      camps: [],
      calculated_camps_ids: [],
      loadedFilters: {},
      mapMoved: false,
      loadingYScript: true,
    };
    this.mapCanvasRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ loadingYScript: true });

    if (typeof ymaps3 == 'undefined') {
      let script = document.createElement('script');

      script.onload = () => {
        ymaps3.ready.then(() => {
          this._initMap();
        });
      };

      script.src = $('#ymaps-lazy-script').data('src');
      document.getElementsByTagName('head')[0].appendChild(script);
    } else {
      ymaps3.ready.then(() => {
        this._initMap();
      });
    }
  }

  loadCamps(mapMoved = false) {
    if (!this.map || !this.map.bounds) return;
    const [[minLng, minLat], [maxLng, maxLat]] = this.map.bounds;

    let url = '/map_camps';
    const { string } = filtersToQuery(this.props.filters, 0, false, this.props.s_params, null, false);
    let search_data = JSON.parse($.cookie('search_data'));
    search_data.date_start = this.props.s_params.date_start;
    search_data.date_end = this.props.s_params.date_end;
    search_data.count_guests = this.props.s_params.count_guests;
    search_data.children_ages = this.props.s_params.children_ages;
    $.cookie('search_data', JSON.stringify(search_data), { path: '/', expires: 60 });
    url += '?';
    url += new URLSearchParams(search_data).toString();
    url += `&exclude_ids=${this.state.calculated_camps_ids.join(',')}`;
    url += `&region_id=${this.props.region_id}`;
    url += `&river_id=${this.props.river_id}`;
    url += `&map_moved=${mapMoved}`;
    if (this.props.city_id) url += `&city_id=${this.props.city_id}`;
    if (this.props.country_id) url += `&country_id=${this.props.country_id}`;
    url += `&min_lng=${minLng}&max_lng=${maxLng}&min_lat=${minLat}&max_lat=${maxLat}`;
    url += `&${string}`;
    this.setState({ loadingCamps: true });
    this.abortController = new AbortController();
    axios
      .get(url, {
        signal: this.abortController.signal,
      })
      .then((res) => {
        this.props.updateHtmlParams(res.data.html_params);
        this.setState(
          (prevState) => {
            return {
              allCamps: [...prevState.allCamps, ...res.data.camps],
              camps: [...prevState.camps, ...res.data.camps],
              html_params: res.data.html_params,
              calculated_camps_ids: [...prevState.calculated_camps_ids, ...res.data.calculated_camps_ids],
            };
          },
          () => {
            const campsInBorders = this.filterCampsInBorder(this.state.camps);
            this.setState({ loadingCamps: false, campsInBorders: campsInBorders });
            this.props.onChangeMapCampsLoaded(true);
            this.initMarkers(campsInBorders);
            this.refreshMap();
          }
        );
      })
      .catch((error) => {
        if (error.name === 'CanceledError') return;
        console.error(error);
      });
  }

  filterCampsInBorder(camps) {
    if (!this.map?.bounds) return [];
    const [[minLng, maxLat], [maxLng, minLat]] = this.map.bounds;

    const res = camps.filter((camp) => {
      return camp.longitude >= minLng && camp.longitude <= maxLng && camp.latitude >= minLat && camp.latitude <= maxLat;
    });

    return sortForMap(res, this.props.camp?.id).slice(0, +this.campsToShowCount + 1 || undefined);
  }

  initMarkers(items) {
    let needle1;
    let marker;
    $('body').on('click', 'div.camp-card .onmap', function () {
      const url = $(this).data('link');
      return window.open(url, '_blank');
    });

    if (!this.markers) this.markers = [];
    if (!this.markerIds) this.markerIds = [];

    const intersected = intersection(this.markerIds, pluck(items, 'id'));
    const to_delete = difference(this.markerIds, intersected);
    const to_init = difference(pluck(items, 'id'), intersected);

    for (marker of Array.from(this.markers)) {
      if (to_delete.includes(marker._campId)) {
        this.map.removeChild(marker);
      }
    }

    this.markerIds = difference(this.markerIds, to_delete);
    this.markers = this.markers.filter((marker) => ((needle1 = marker._campId), this.markerIds.includes(needle1)));

    for (let item of Array.from(items)) {
      if (to_init.includes(item.id)) {
        marker = this.createMarker(item);
        this.markerIds.push(item.id);
        this.markers.push(marker);
        this.map.addChild(marker);
      }
    }

    this.initMarkerEventListeners();
  }

  openBalloon(marker, delay) {
    this.hoverTimeout = setTimeout(() => {
      this.mouseOnMarker = true;
      const camps = this.state.allCamps;
      let camp = camps.find((camp) => camp.id == marker._campId);
      if (!camp) return;

      this.setState({ allCamps: camps, balloonCamp: camp }, () => {
        this.renderBalloon(marker, camp);
        marker.update({ zIndex: zIndexForMapMarker(marker._camp, this.props.mapCampId, true) });
        marker.element.classList.add('show-balloon');
        this.refreshMap([marker]);
      });

      for (let m of this.markers) {
        if (m !== marker) {
          m.element.classList.remove('show-balloon');
          m.update({ zIndex: zIndexForMapMarker(m._camp, this.props.mapCampId) });
        }
      }
    }, delay);
  }

  refreshMap(markers_to_update = null) {
    const markers = markers_to_update ?? this.markers;
    for (let marker of markers) {
      const needle = marker._campId;
      const camp = this.state.allCamps.find((item) => item.id === needle);

      const isCentered = camp.id === this.props.mapCampId || needle === this.state.balloonCamp?.id;

      marker.update({
        zIndex: zIndexForMapMarker(camp, this.props.mapCampId, isCentered),
      });

      if (this.props.showManagerMap) {
        marker._iconEl.innerHTML = this.generateManagerLayout(camp, true, isCentered);
      } else {
        marker._iconEl.innerHTML = this.generateMarkerLayout(camp, true, isCentered);
      }
    }
  }

  markerIcon(item, selected = false) {
    let iconClass = '';

    if (this.props.favorites.includes(item.id)) {
      iconClass = selected ? 'unfavorite-icon selected' : 'unfavorite-icon';
    } else if (item.is_can_instant_booking) {
      const baseClass = selected ? 'icon-flash_white' : 'icon-instant-fill';
      iconClass = `icon ${baseClass} ${baseClass}-dims`;
    }

    return `<div id="placemark-icon" class='${iconClass}'></div>`;
  }

  discountIcon(discount, selected) {
    if (!discount) return '';
    return `<div class='discount-icon ${selected ? 'selected' : ''}'></div>`;
  }

  generateMarkerLayout(camp, suitable = false, selected = false) {
    const { priceMin, discount } = this.getTariffData(camp);
    let classes = 'placemark_layout_container';
    if (!suitable) classes += ' not_suitable';
    if (selected) classes += ' selected';
    classes += priceMin > 0 ? ' wide' : ' empty';

    const icon = this.markerIcon(camp, selected);

    return `<div class="${classes}" data-camp-id="${camp.id}">
         ${icon}
         ${priceMin > 0 ? Math.floor(priceMin).toLocaleString('ru-RU') + ' ₽' : '•'}
         ${this.discountIcon(discount, selected)}
       </div>`;
  }

  createMarker(camp) {
    const el = document.createElement('div');
    el.className = 'marker-root';

    const icon = document.createElement('div');
    icon.className = 'marker-icon';

    const balloon = document.createElement('div');
    balloon.className = 'marker-balloon';

    el.appendChild(icon);
    el.appendChild(balloon);

    const marker = new this.YMapMarker(
      {
        coordinates: [camp.longitude, camp.latitude],
        zIndex: zIndexForMapMarker(camp, this.props.camp?.id),
      },
      el
    );

    marker._campId = camp.id;
    marker._url = camp.seo_path;
    marker._camp = camp;
    marker._iconEl = icon;
    marker._balloonEl = balloon;

    return marker;
  }

  getTariffData(camp) {
    let bonuses, tariff, allGuestCount, discount;

    const apartments = camp.apartments;
    const complexPlacement = camp.complex_placement;

    if (complexPlacement) {
      bonuses = complexPlacement.total_bonuses;
      tariff = complexPlacement.items?.[0]?.tariff;
      allGuestCount = complexPlacement.total_guests;
    } else if (apartments) {
      bonuses = apartments[0]?.bonuses;
      tariff = apartments[0]?.tariffs[0];
      allGuestCount = (tariff?.seats ?? 0) + (tariff?.seats_additional ?? 0) + (tariff?.child_count_no_seats ?? 0);
      discount = tariff?.discount;
    }

    const priceMin = tariff?.calculated_price ?? null;
    const priceMinWithoutDiscount = tariff?.calculated_price_without_discount ?? null;

    return {
      tariff,
      bonuses: bonuses ?? 0,
      priceMin,
      priceMinWithoutDiscount,
      allGuestCount,
      discount: discount ?? 0,
    };
  }
}
